import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { useGetPayload } from './use-get-change-plan-payload';
import { sellerSubscriptionPlanInfoUpdated } from '../../../../../../store/seller/seller.actions';
import { migrateToPromotionalPlan } from '../../../../api/subscription';

/** @typedef {import('../types').PlanDetails} PlanDetails */

/**
 *
 * @param {PlanDetails} promotionalPlanDetails
 * @returns {{ isRequestingPlanChange: boolean, onChangePlan: Promise<void> }}
 */
export const useGetChangePlanHandler = (promotionalPlanDetails) => {
  const dispatch = useDispatch();
  const [isRequesting, setIsRequesting] = useAsyncSafeState(false);

  const payload = useGetPayload(promotionalPlanDetails);

  const onChangePlan = useCallback(async () => {
    setIsRequesting(true);

    try {
      await migrateToPromotionalPlan(payload);
      dispatch(sellerSubscriptionPlanInfoUpdated());
      // don't catch here so caller can log and do stuff
    } finally {
      setIsRequesting(false);
    }
  }, [dispatch, payload, setIsRequesting]);

  return {
    isRequestingPlanChange: isRequesting,
    onChangePlan,
  };
};
